import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from "vue";
export interface Props {
	value?: boolean;
	disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Switcher',
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }) {

const props = __props as { value: boolean, disabled: boolean }





const emitToggle = () => {
	if (!props.disabled) {
		emit("toggle", !props.value);
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center bg-gray-300 rounded-full w-12 h-6 p-1 transition-colors min-w-[3rem]", { 'bg-blue-900': __props.value }]),
    onClick: emitToggle
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["h-5 w-5 rounded-full shadow-md transform bg-white transition-transform", { 'translate-x-5 ': __props.value }])
    }, null, 2)
  ], 2))
}
}

})